import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"

import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import GenericModal from "@irati/ui/src/GenericModal"
import History from "@irati/utils/history"
import myVote from "@irati/recognition/utils/polls/myVote"

import ViewVotes from "./ViewVotes"
import CreateVote from "./CreateVote"

export const VIEW = "VIEW"
export const CREATE = "CREATE"

const modals = [VIEW, CREATE]

interface Props {
  redirectToFeed?: boolean
  poll: any
  showViewVotes?: boolean
  onAfterExitModal?: () => void
}

interface State {
  show: {[key: string]: boolean}
}

class Popup extends Component<Props, State> {
  state = {
    show: modalStory(modals, null)
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  show = (modalToShow = CREATE) => {
    this.setState({
      show: modalStory(modals, modalToShow)
    })
  }

  handleHide = () => {
    this.setState({
      show: modalStory(modals, null)
    })
  }

  handleAfterExit = () => {
    const {redirectToFeed, onAfterExitModal} = this.props
    if (!anyStoriesOpen(this.state.show)) {
      if (redirectToFeed) {
        History.push("/polls", this.context, {scrollToTop: false})
      }
      if (typeof onAfterExitModal === "function") {
        onAfterExitModal()
      }
    }
  }

  handleDeleteSuccess = () => {
    const {redirectToFeed, onAfterExitModal} = this.props
    if (redirectToFeed) {
      History.push("/polls", this.context, {scrollToTop: false})
    }
    if (typeof onAfterExitModal === "function") {
      onAfterExitModal()
    }
  }

  getView() {
    const {poll, showViewVotes} = this.props
    return showViewVotes || myVote(poll) ? VIEW : CREATE
  }

  componentDidMount() {
    this.show(this.getView())
  }

  render() {
    const {show} = this.state
    const {poll} = this.props

    return (
      <Fragment>
        <GenericModal show={show[VIEW]} onHide={this.handleHide} onExited={this.handleAfterExit} hideActions image={poll.trophy.href}>
          <ViewVotes poll={poll} onDeleteSuccess={this.handleDeleteSuccess} />
        </GenericModal>
        <GenericModal show={show[CREATE]} onHide={this.handleHide} onExited={this.handleAfterExit} hideActions image={poll.trophy.href}>
          <CreateVote poll={poll} onDeleteSuccess={this.handleDeleteSuccess} selectScreen={this.show} />
        </GenericModal>
      </Fragment>
    )
  }
}

export default Popup
